import { JsonPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IAuditTrail } from "@ramudden/models/audit-trail";
import { CodeHighlightComponent } from "../code-highlight/code-highlight.component";

@Component({
    selector: "app-audit-trail-details",
    templateUrl: "./audit-trail-details.component.html",
    imports: [CodeHighlightComponent, JsonPipe],
})
export class AuditTrailDetailsComponent {
    @Input() auditTrail: IAuditTrail;
}
